import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { IBookmark, IPreFactor, IMarker, IUserSettings, IUserSlice, IVideoSettings, IFactor } from "../../interfaces/interfaces"

const UserSliceState: IUserSlice = {
    userId: "",
    xToken: "",
    authToken: "",
    refreshToken: "",
    avatar_url: "",
    name: "",
    phone_number: "",
    isLogin: false,
    selectedPersonalMarker: undefined,
    settings: {
        quality: -1,
        brightness: 100,
        volume: 100,
        speed: 1,
        poll_emoji: true
    },
    videoSettings: {
        is_like: null,
        time: 0
    },
    bookmarks: [],
    bookmarkId: undefined,
    voucherToken: undefined,
    showVoucherPopup: false,
    preFactor: undefined,
    factor: undefined,
    showContinuousePlayback: true,
}

export const userSlice = createSlice({
    name: 'user',
    initialState: UserSliceState,
    reducers: {
        setUserId: (state, action: PayloadAction<string>) => {
            state.userId = action.payload
        },
        setXToken: (state, action: PayloadAction<string>) => {
            state.xToken = action.payload
        },
        setAuthToken: (state, action: PayloadAction<string>) => {
            state.authToken = action.payload
        },
        setRefreshToken: (state, action: PayloadAction<string>) => {
            state.refreshToken = action.payload
        },
        setUserInfo: (state, action: PayloadAction<any>) => {
            state.avatar_url = action.payload.avatar_url;
            state.name = action.payload.name;
            state.phone_number = action.payload.phone_number;
            state.userId = action.payload.userid;
            state.isLogin = true;
        },
        setSelectedPersonalMarker: (state, action: PayloadAction<undefined | IMarker>) => {
            state.selectedPersonalMarker = action.payload
        },
        setUserSettings: (state, action: PayloadAction<IUserSettings>) => {
            state.settings = action.payload
        },
        setVideoSettings: (state, action: PayloadAction<IVideoSettings>) => {
            state.videoSettings = action.payload
        },
        setBookamrks: (state, action: PayloadAction<IBookmark[]>) => {
            state.bookmarks = action.payload
        },
        setBookmarkId: (state, action: PayloadAction<number | undefined>) => {
            state.bookmarkId = action.payload
        },
        setVoucherToken: (state, action: PayloadAction<string | undefined>) => {
            state.voucherToken = action.payload
        },
        setShowVoucherPopup: (state, action: PayloadAction<boolean>) => {
            state.showVoucherPopup = action.payload
        },
        setPreFactor: (state, action: PayloadAction<IPreFactor | undefined>) => {
            state.preFactor = action.payload
        },
        setFactor: (state, action: PayloadAction<IFactor | undefined>) => {
            state.factor = action.payload
        },
        setShowContinuousePlayback: (state, action: PayloadAction<boolean>) => {
            state.showContinuousePlayback = action.payload
        },
        setClearUserSlice: () => {
            return UserSliceState;
        }
    }
})

export const {
    setUserId,
    setXToken,
    setAuthToken,
    setRefreshToken,
    setUserInfo,
    setSelectedPersonalMarker,
    setUserSettings,
    setVideoSettings,
    setBookamrks,
    setBookmarkId,
    setVoucherToken,
    setShowVoucherPopup,
    setPreFactor,
    setFactor,
    setShowContinuousePlayback,
    setClearUserSlice
} = userSlice.actions;

export default userSlice.reducer;